import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { Redirect, useParams } from 'react-router-dom';
import { Avatar } from '@material-ui/core';
import FakturDownloadPage from './faktur-download-page';
import { findPortalCustomization } from './services/customization.service';

function CustomEfakturDownloadPage() {
  const { customerPrefix: prefixInput } = useParams();

  const [customerPrefix] = useState(prefixInput);
  const [loading, setLoading] = useState(true);
  const [redirect, setRedirect] = useState(false);
  const [customization, setCustomization] = useState({});

  useEffect(() => {
    async function getCustomization() {
      const portalCustomization = await findPortalCustomization(customerPrefix);
      const { ok } = portalCustomization;
      setRedirect(!ok);
      if (ok) {
        const body = await portalCustomization.json();
        setCustomization(body);
      }
      setLoading(false);
    }

    getCustomization();
  }, [customerPrefix]);

  if (loading) {
    return (
      <Grid
        container={true}
        direction="column"
        alignItems="center"
        justify="center"
      >
        <Grid item={true}>
          <Avatar src="/OP.png" />
        </Grid>
      </Grid>
    );
  }
  if (redirect) {
    return (<Redirect to="/" />);
  }

  return (<FakturDownloadPage portalCustomization={customization} isDefaultPage={false} />);
}

export default CustomEfakturDownloadPage;
